export { default as Chat } from './page'


// WEBPACK FOOTER //
// ./src/pages/chat/index.js